import { useContext, useState } from "react";
import styled, { ThemeContext } from "styled-components";
import { space, SpaceProps } from "styled-system";
import css from "@styled-system/css";

import { RadioButtonProps } from "./radioButton.type";

const Label = styled.label<{ css?: string } & SpaceProps>`
  display: inline-block;
  width: auto;
  position: relative;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  ${space}
  ${(props) => props.css}
`;

const SpanText = styled.span`
  width: auto;
  ${css({
    fontSize: "body",
    fontFamily: "normal",
    fontWeight: "normal",
    paddingLeft: 3,
  })}
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  color: "black";
`;

const Input = styled.input`
  opacity: 0;
  width: 24px;
  height: 24px;
  position: absolute;
  left: 0.5em;
  top: 0.4em;
  cursor: pointer;

  &:checked + svg {
    border-radius: 50%;
    outline: none;
  }

  &:focus:not(:focus-visible) + svg {
    outline: none;
    cursor: pointer;
  }

  &:disabled + svg,
  &:disabled ~ span {
    opacity: 0.5;
    cursor: default;
  }
`;

const getSVG = (isSelected: boolean, fill: string) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height="24"
      width="24"
      style={{
        borderRadius: "50%",
      }}
    >
      {isSelected ? (
        <circle fill={fill} cx="12" cy="12" r="12" />
      ) : (
        <circle
          fill="none"
          cx="12"
          cy="12"
          r="11"
          stroke="#bebfbe"
          strokeWidth="2"
        />
      )}
      <circle fill={isSelected ? "#fff" : "none"} cx="12" cy="12" r="4" /> :
    </svg>
  );
};

const RadioButton = ({
  value,
  label,
  isSelected,
  onChange,
  disabled,
  analytics,
  children,
  id,
  css,
}: RadioButtonProps) => {
  const [identifier] = useState(`option-${Math.random()}`);
  const { colors } = useContext(ThemeContext);

  const eventName = analytics ? "click" : undefined;
  const eventCategory = analytics
    ? analytics?.eventCategory || "select"
    : undefined;

  return (
    <Label
      htmlFor={id || identifier}
      py={2}
      data-en={eventName}
      data-ec={eventCategory}
      data-el={analytics?.eventLabel}
      data-ea={analytics?.eventAction}
      data-es={analytics?.eventSection}
      data-et={analytics?.eventType}
      data-ev={analytics?.eventValue}
      css={css}
    >
      <Input
        type="radio"
        id={id || identifier}
        checked={isSelected}
        value={value}
        aria-label={label}
        onChange={onChange}
        disabled={disabled}
      />
      {getSVG(isSelected || false, colors["radio-fill-color"])}
      {children || <SpanText>{label}</SpanText>}
    </Label>
  );
};

export default RadioButton;
